import { FunctionComponent, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { GrowlNotification } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../store/reducers';
import { closeGrowlNotification } from '../../store/actions';
import history from './../../history';

const GlobalGrowlNotification: FunctionComponent = () => {
  const { text, i18nKey, variant, show, autoCloseInMs, linkText, linkHref } = useSelector(
    (state: RootState) => state.notifications.notification,
    shallowEqual,
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const unlistenRef = useRef(() => {});

  useEffect(() => {
    // Automatic close
    if (autoCloseInMs) {
      setTimeout(() => {
        dispatch(closeGrowlNotification());
      }, autoCloseInMs);
    }

    if (show) {
      unlistenRef.current();
      unlistenRef.current = history.listen(() => {
        dispatch(closeGrowlNotification());
        unlistenRef.current();
        unlistenRef.current = () => {};
      });
    } else {
      unlistenRef.current();
      unlistenRef.current = () => {};
    }
  }, [show, autoCloseInMs, dispatch]);

  useEffect(() => {
    return () => {
      unlistenRef.current();
    };
  }, []);

  return (
    <GrowlNotification
      shown={show}
      variant={variant}
      notification={i18nKey ? t(i18nKey) : text}
      ctaText={linkText}
      ctaTo={linkHref}
      closeOnClick={() => dispatch(closeGrowlNotification())}
    />
  );
};

export default GlobalGrowlNotification;
